import { subscriptionTypes, SubscriptionTypeTypes } from '@/modules/base/util/constants'
import request from '@/modules/base/util/request'
import config from '@/modules/cello/config'
import { setCelloBooted } from '@/redux/ducks/global'
import store from '@/redux/store'
import { isMeinBuero } from '@/utils/build-env'

const { endpoints } = config
const isMB = isMeinBuero()

export default class CelloService {
  static async boot(): Promise<void> {
    try {
      if (isMB) { return }
      if (store.getState().global.isCelloBooted) {
        return console.log('CELLO already booted')
      }

      const { body: { productId, token } } = await request(`${endpoints.getToken}`, { method: 'GET', auth: true })

      const subscriptions = store.getState().subscription?.details?.subscriptions
      if (!subscriptions) {
        return
      }

      const hasActiveMainSubscription = subscriptions
        .filter(sub => sub.type !== subscriptionTypes.FREE_2025)
        .filter(sub => !sub.isSubscriptionLocked && !sub.isTrial && !sub.isExpired && sub.typeOfSubscription === SubscriptionTypeTypes.Main).length === 1

      if (!hasActiveMainSubscription) {
        return
      }

      window['cello'] = window['cello'] || { cmd: [] }
      window['cello'].cmd.push(async(cello) => {
        try {
          const userInfo = store.getState().user.info
          await cello.boot({
            productId,
            token,
            language: 'de',
            productUserDetails: {
              firstName: userInfo?.firstName,
              lastName: userInfo?.lastName,
              fullName: `${userInfo?.firstName ?? ''} ${userInfo?.lastName ?? ''}`,
              email: userInfo?.email,
            },
          })
          store.dispatch(setCelloBooted(true))
        } catch (error) {
          // swallow error
          console.error(error)
        }
      })
    } catch (error) {
      // swallow error
      console.error('CELLO boot error', error)
    }
  }

  static async shutdown(): Promise<void> {
    try {
      if (isMB) { return }

      window['cello'] = window['cello'] || { cmd: [] }
      window['cello'].cmd.push(async(cello) => {
        cello.shutdown()
        store.dispatch(setCelloBooted(false))
      })
    } catch (error) {
      // swallow error
      console.error('CELLO shutdown error', error)
    }
  }

  static async getUcc(): Promise<string> {
    return new Promise(async(resolve) => {
      try {
        if (isMB) { return resolve(null) }

        const referralCode = await window['CelloAttribution']('getUcc')
        resolve(referralCode)
      } catch (error) {
        // return null if there is an error retriving the referralCode
        console.error('CELLO getUcc error', error)
        resolve(null)
      }
    })
  }
}
